import { Home, Compass, HeartHandshake, Hammer, BookOpen, Sunrise, Users } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SERVE_ITEMS, IMAGES } from "../data/content";

const ICONS = { Home, Compass, HeartHandshake, Hammer, BookOpen, Sunrise, Users };

export const Serve = () => (
  <section
    id="serve"
    data-testid="seven-ways-serve-section"
    className="grain relative overflow-hidden bg-obsidian py-20 lg:py-28"
  >
    <img
      src={IMAGES.mountainWater}
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.12]"
    />
    <div className="relative mx-auto max-w-[1500px] px-6 lg:px-12">
      <Reveal>
        <Eyebrow tone="gold">Our Values</Eyebrow>
      </Reveal>

      <div className="mt-10 grid gap-px bg-sand/15 sm:grid-cols-2 lg:grid-cols-4">
        {SERVE_ITEMS.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <Reveal key={item.no} delay={0.05 * i}>
              <div
                data-testid={`serve-card-${i + 1}`}
                className="group flex h-full flex-col gap-4 bg-obsidian p-7 transition-colors duration-500 hover:bg-navy/40"
              >
                <div className="flex items-center justify-between">
                  <Icon size={20} className="text-crimson" />
                  <span className="font-mono-accent text-[0.64rem] text-gold/70">{item.no}</span>
                </div>
                <h3 className="font-display text-lg leading-snug text-sand">{item.title}</h3>
                <p
                  data-testid={`serve-body-${i + 1}`}
                  className="text-sm leading-relaxed text-sand/60"
                >
                  {item.body}
                </p>
              </div>
            </Reveal>
          );
        })}

        <Reveal delay={0.4}>
          <div className="flex h-full flex-col justify-between bg-crimson p-7">
            <span className="label-eyebrow text-sand/60">Faith · Hope · Love</span>
            <p className="font-display mt-10 text-lg italic leading-snug text-sand">
              “And now these three remain.”
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
